export class BrokerCommissionModel {

  firstName: string;
  lastName: string;
  totalCommission: string;
  adminFee: string;

}
